
<div class="flex-box" fillComponentParentView="fillComponentParentView">
  <div class="flex-heading">
    <div class="list-header col-xs-12"><span class="pR15">Coupons ({{tableCount}})</span>
      <div class="pull-right"><i class="fa fa-plus-square-o m-l-xs pointer" routerLink="new"></i></div>
    </div>
  </div>
  <div class="flex-content scroll-x">
    <div class="list-view">
      <div class="list-sidebar">
        <div class="header">
          <div class="title">Filters</div>
          <button class="btn-xxs btn-secondary" (click)="resetFilters()">Reset</button>
        </div>
        <div class="content">
          <div class="flex">
            <label class="mr-3">Active</label>
            <label data-testid="auto-refresh-switch" class="i-switch i-switch-sm bg-success">
              <input type="checkbox" [(ngModel)]="active" (ngModelChange)="reset()" name="autoRefresh"/><i></i>
            </label>
          </div>
          <div>
            <label class="db">Search</label>
            <input class="w100" placeholder="Code, Name, Amount, Percentage" (change)="reset()" [(ngModel)]="searchKey"/>
          </div>
          <div>
            <label class="db">Year</label>
            <input class="w100" type="number" min="1900" max="2099" step="1" placeholder="eg 2022,2023" [(ngModel)]="year" (change)="reset()"/>
          </div>
        </div>
      </div>
      <div class="list-content">
        <ag-grid-angular class="ag-theme-balham" style="height: 100%;" [columnDefs]="columnDefs" [components]="components" [rowBuffer]="0" [rowModelType]="ui.grid.rowModelType" [paginationPageSize]="ui.grid.pageSize" [cacheBlockSize]="ui.grid.pageSize" [cacheOverflowSize]="1" [maxConcurrentDatasourceRequests]="1" [infiniteInitialRowCount]="1" [maxBlocksInCache]="10" (gridReady)="onGridReady($event)"></ag-grid-angular>
      </div>
    </div>
  </div>
</div>